'use client';

import { type HTMLAttributes, type ReactNode } from 'react';

import { clsx } from '@/libs';

type BottomFixedFooterProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

export const BottomFixedFooter = ({
  children,
  className,
  ...props
}: BottomFixedFooterProps) => {
  return (
    <div className={clsx('w-full', className)} {...props}>
      {children}
    </div>
  );
};
